module.exports = __webpack_public_path__ + "pc/img/modal_16.9b60490a.png";